import type { DmMessageFrustration } from '../../../../services/dmMessagesInbox';

// 'unset' stands in for the API's null, which can't key a record.
export type FrustrationOption = 'low' | 'medium' | 'high' | 'unset';

interface FrustrationMeta {
    label: string;
    description: string;
    litBars: 0 | 1 | 2 | 3;
    // Trigger button, mirroring the priority button tones.
    buttonTone: string;
    chevronTone: string;
    buttonGlyphTone: string;
    bold: boolean;
    // Menu row.
    menuGlyphTone: string;
    menuLabelTone: string;
}

// Low/not set read like Normal and medium like High; high is soft red, since solid red marks Extreme.
export const FRUSTRATION_META: Record<FrustrationOption, FrustrationMeta> = {
    low: {
        label: 'Low',
        description: 'Calm, just keeping us posted',
        litBars: 1,
        buttonTone: 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50',
        chevronTone: 'text-gray-400',
        buttonGlyphTone: 'text-gray-500',
        bold: false,
        menuGlyphTone: 'text-gray-500',
        menuLabelTone: 'text-gray-700'
    },
    medium: {
        label: 'Medium',
        description: 'Some impatience is showing',
        litBars: 2,
        buttonTone: 'border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100',
        chevronTone: 'text-amber-500',
        buttonGlyphTone: 'text-amber-500',
        bold: true,
        menuGlyphTone: 'text-amber-600',
        menuLabelTone: 'text-amber-700'
    },
    high: {
        label: 'High',
        description: 'Upset, so reply with care',
        litBars: 3,
        buttonTone: 'border-red-200 bg-red-50 text-red-700 hover:bg-red-100',
        chevronTone: 'text-red-400',
        buttonGlyphTone: 'text-red-500',
        bold: true,
        menuGlyphTone: 'text-red-600',
        menuLabelTone: 'text-red-700'
    },
    unset: {
        label: 'Not set',
        description: 'No read on their mood yet',
        litBars: 0,
        buttonTone: 'border-gray-200 bg-white text-gray-500 hover:bg-gray-50',
        chevronTone: 'text-gray-400',
        buttonGlyphTone: 'text-gray-400',
        bold: false,
        menuGlyphTone: 'text-gray-400',
        menuLabelTone: 'text-gray-700'
    }
};

export const RATED_FRUSTRATION_OPTIONS: readonly FrustrationOption[] = ['low', 'medium', 'high'];

export function toFrustrationOption(value: DmMessageFrustration): FrustrationOption {
    return value ?? 'unset';
}

export function fromFrustrationOption(option: FrustrationOption): DmMessageFrustration {
    return option === 'unset' ? null : option;
}
